import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, createSlots as _createSlots } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "d-block w-100" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-center justify-space-between"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "d-flex gap-2 mt-3" }

import CommentModel from '../../../api/v2/models/comment'
import User from '../../models/user'
import Simplemde from './Simplemde.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Comment',
  props: {
    comment: {},
    user: {},
    deleteComment: { type: Function },
    updateComment: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_list_item, { class: "px-0" }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        (!__props.comment.isEditing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", {
                innerHTML: __props.comment.renderedBody,
                class: _normalizeClass(`html-body comment-html-body-${__props.comment.id}`)
              }, null, 10 /* CLASS, PROPS */, _hoisted_4),
              (__props.comment.user && __props.user && __props.comment.user.id == __props.user.id)
                ? (_openBlock(), _createBlock(_component_v_menu, { key: 0 }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        icon: "",
                        variant: "text",
                        size: "x-small"
                      }, props, { class: "ml-2" }), {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { size: "small" }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("mdi-dots-vertical", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }, 16 /* FULL_PROPS */)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, {
                        density: "compact",
                        class: "py-0"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.comment.isEditing = true))
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_v_icon, { size: "small" }, {
                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                  _createTextVNode("mdi-pencil", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                  _createTextVNode("編集", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.deleteComment(__props.comment.id))),
                            class: "text-error"
                          }, {
                            prepend: _withCtx(() => [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                color: "error"
                              }, {
                                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                  _createTextVNode("mdi-delete", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                  _createTextVNode("消去", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(Simplemde, {
                modelValue: __props.comment.body,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.comment.body) = $event)),
                rows: 3,
                name: "comment-body-new"
              }, null, 8 /* PROPS */, ["modelValue"]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_v_btn, {
                  color: "primary",
                  class: "px-4",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (__props.updateComment(__props.comment)))
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("コメントを送信する", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_v_btn, {
                  variant: "outlined",
                  class: "px-4",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (__props.comment.isEditing = false))
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("キャンセル", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ])
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (__props.comment.user && __props.comment.user.image)
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            _createVNode(_component_v_avatar, { size: "40" }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: __props.comment.user.image.url
                }, null, 8 /* PROPS */, _hoisted_1)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1024 /* DYNAMIC_SLOTS */))
}
}

})